import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SettingsService } from '../services';

@Injectable({
    providedIn: 'root'
})
export class IndexGuard  {

    memoryStorage;
    guest;

    constructor(private settingsService: SettingsService, private router: Router) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (!this.settingsService.showAuthPage) {
            return true;
        } else {
            this.router.navigateByUrl('/auth/signin');
            return false;
        }
    }
}
